// src/app/chart.config.ts
import { Chart } from 'chart.js';
import * as ChartAnnotation from 'chartjs-plugin-annotation';

// ✅ Register plugin only once
if (!(Chart as any).annotationRegistered) {
  Chart.plugins.register(ChartAnnotation);
  (Chart as any).annotationRegistered = true; // marker to avoid re-register
}
